// extracted by mini-css-extract-plugin
export default {"vacancy":"VacancyDescription_vacancy__kCgVk","list":"VacancyDescription_list__U13Tr"};